import PropTypes from 'prop-types';
import { buildInitialIntlAttribute } from 'shared/lib/intl';

export const propTypes = {
  id: PropTypes.string,
  slug: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.shape(buildInitialIntlAttribute(PropTypes.string)),
  ico: PropTypes.string,
  dic: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  www: PropTypes.string,
  size: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string
  }),
  zip: PropTypes.string,
  logo: PropTypes.string,
  agency: PropTypes.bool
};

export const defaultProps = {
  id: null,
  slug: null,
  name: '',
  description: buildInitialIntlAttribute(''),
  ico: '',
  dic: '',
  email: '',
  phone: '',
  www: '',
  size: null,
  street: '',
  city: {},
  zip: '',
  logo: null,
  agency: false
};

export default { defaultProps, propTypes };
